var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index},[(_vm.isVisible(block))?_c(block.typeHandle,_vm._b({tag:"component",attrs:{"products-connection":block.typeHandle === 'productGrid' && _vm.collection ? _vm.collection.products : null,"grid-blocks":_vm.gridBlocks}},'component',block,false)):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }